<template>
  <div class="footer">
    <div class="container footer-up">
      <div class="footer-row">
        <!-- 左侧：Logo + 客服二维码 -->
        <div class="left block-cotorl">
          <div class="logo-box">
            <img :src="logoBY" width="48" alt="logo" />
            <div class="logo-text-box">
              <span class="logo-text">豹眼背调</span>
              <span class="logo-text-zm">baoyanbd.com</span>
            </div>
          </div>
          <div class="qrcode">
            <img
              :src="serviceUrl"
              width="114"
              height="114"
              alt="客服微信"
              v-if="serviceUrl"
            />
            <div class="empty-qrcode" v-else></div>
          </div>
          <p class="t-c sub-title">联系客服</p>
        </div>

        <!-- 右侧：多列信息 -->
        <div class="right">
          <div class="footer-cols">
            <!-- 友情链接 -->
            <div class="footer-col block-cotorl">
              <div class="title">友情链接</div>
              <div class="sub-title">
                <a
                  href="http://www.court.gov.cn/"
                  target="_blank"
                  rel="noopener"
                  >最高人民法院</a
                >
                <a
                  href="http://www.pbccrc.org.cn/"
                  target="_blank"
                  rel="noopener"
                  >中国人民银行征信中心</a
                >
                <a
                  href="http://www.gsxt.gov.cn/index.html"
                  target="_blank"
                  rel="noopener"
                  >国家企业信用信息公示系统</a
                >
                <a
                  href="http://www.mohrss.gov.cn/"
                  target="_blank"
                  rel="noopener"
                  >人社局</a
                >
              </div>
            </div>

            <!-- 快速入口 -->
            <div class="footer-col block-cotorl">
              <div class="title">快速入口</div>
              <div class="sub-title">
                <router-link to="/industry">场景使用</router-link>
                <router-link to="/service">产品与服务</router-link>
                <router-link to="/about" class="dis-inBlock"
                  >了解我们</router-link
                >
              </div>
            </div>

            <!-- 联系我们 -->
            <div class="footer-col" style="flex: 2">
              <div class="title">联系我们</div>
              <div class="sub-title">
                <div class="info-item">
                  <span class="info-label">邮箱：</span>
                  <span class="info-value">invoice@baoyanbd.com</span>
                </div>
                <div class="info-item">
                  <span class="info-label">电话：</span>
                  <span class="info-value">400-8600-575</span>
                </div>
                <div class="info-item address-item">
                  <span class="info-label">地址：</span>
                  <span class="info-value"
                    >湖北省武汉市汉阳区江堤街道金地兰亭长江序21栋汉上观1716室</span
                  >

                  <!-- <span class="info-value">湖北省武汉东湖新技术开发区光谷大道41号现代·国际设计城三期10号研发楼栋7层01号</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权 -->
    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <span>Copyright © 武汉云查信息技术有限公司 版权所有</span>
        <span class="beian-label">
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener"
          >
            鄂ICP备2026037097号-1
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      logoBY: require('@/assets/images/logo_yun2.png'),
      // serviceUrl: ''
    };
  },
  computed: {
    // 实时响应vuex变化，store一旦更新自动触发视图刷新
    serviceUrl() {
      return this.$store.getters.customerUrl || '';
    },
  },
  mounted() {
    // this.serviceUrl = this.$store.state.customerUrl || '';
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 64px 0 0;
  background: #092540;
  color: #fff;
}

.footer-up {
  padding-bottom: 62px;
}

.footer-row {
  display: flex;
  align-items: flex-start;
}

/* ========== 左侧区域 ========== */
.left {
  flex-shrink: 0;
  padding-right: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .qrcode {
    margin: 32px 0 5px;
    border-radius: 4px;
    overflow: hidden;

    .empty-qrcode {
      width: 114px;
      height: 114px;
      background: white;
    }
  }

  .sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;
  }
}

/* ========== 右侧区域 ========== */
.right {
  flex: 1;
  max-width: 900px;
}

.footer-cols {
  display: flex;
}

.footer-col {
  flex: 1;
  padding: 0 45px;

  .title {
    margin: 18px 0 40px;
    font-size: 14px;
    font-weight: 600;
    color: #84929f;
    line-height: 14px;
  }

  .sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;

    > a {
      display: block;
      margin-bottom: 24px;
      color: #fff;

      &:hover {
        color: #84929f;
      }
    }

    > p {
      margin: 0 0 24px;
    }

    a.dis-inBlock {
      margin-right: 24px;
      display: inline-block;
    }
  }

  .to-kefu {
    color: #fff;

    &:hover {
      color: #84929f;
    }
  }
}

.info-item {
  display: flex;
  margin-bottom: 16px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }
}

.info-label {
  flex-shrink: 0;
  white-space: nowrap;
}

.info-value {
  flex: 1;
  word-break: break-all;
}

.address-item .info-value {
  word-break: break-word;
}

.footer-bottom {
  border-top: 1px solid #2d455c;
  padding: 18px 0;
}

.footer-bottom-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 0 20px;
  font-size: 12px;
  color: #ccc;
  line-height: 12px;

  .beian-label {
    margin-left: 30%;
  }

  a {
    color: #ccc;

    &:hover {
      color: #fff;
    }
  }
}

/* ========== Logo样式 ========== */
.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .logo-text-box {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .logo-text {
      font-size: 18px;
      font-weight: bold;
      color: white;
    }

    .logo-text-zm {
      font-size: 12px;
      color: white;
    }
  }
}

/* ========== 响应式布局 ========== */

/* 平板及以下（≤ 992px） */
@media (max-width: 992px) {
  .block-cotorl {
    display: none;
  }

  .footer {
    padding: 30px 0 0;
  }

  .footer-up {
    padding-bottom: 0;
  }

  .footer-col {
    margin-bottom: 30px;
    padding: 0;

    .title {
      font-size: 13px;
      margin: 8px 0 12px;
    }

    .sub-title {
      > a,
      > p {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }
}

/* 手机端 */
@media (max-width: 767px) {
  .block-cotorl {
    display: none;
  }

  .footer {
    padding: 30px 0 0;
  }

  .footer-up {
    padding-bottom: 0;
  }

  .left {
    .qrcode {
      img,
      .empty-qrcode {
        width: 76px !important;
        height: 76px !important;
      }
    }
  }

  .logo-box {
    img {
      width: 30px !important;
    }

    .logo-text-box {
      .logo-text {
        font-size: 13px;
      }

      .logo-text-zm {
        font-size: 9px;
      }
    }
  }

  .footer-col {
    margin-bottom: 30px;
    padding: 0;

    .title {
      font-size: 13px;
      margin: 8px 0 12px;
    }

    .sub-title {
      > a,
      > p {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }

  .info-item {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .footer-bottom-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding: 0 20px;
    font-size: 12px;
    color: #ccc;
    line-height: 12px;

    .beian-label {
      margin-left: 0;
    }
  }
}
</style>
